'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectRoutes = exports.addPattern = exports.getRoutes = exports.getLocInfo = undefined;

var _mapValues2 = require('lodash/fp/mapValues');

var _mapValues3 = _interopRequireDefault(_mapValues2);

var _get2 = require('lodash/fp/get');

var _get3 = _interopRequireDefault(_get2);

var _set2 = require('lodash/set');

var _set3 = _interopRequireDefault(_set2);

var _transform2 = require('lodash/transform');

var _transform3 = _interopRequireDefault(_transform2);

var _isString2 = require('lodash/isString');

var _isString3 = _interopRequireDefault(_isString2);

var _curry2 = require('lodash/curry');

var _curry3 = _interopRequireDefault(_curry2);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

exports.getLoc = getLoc;
exports.findRoute = findRoute;
exports.routeInfoSelector = routeInfoSelector;
exports.getHref = getHref;

var _capeLodash = require('cape-lodash');

var _capeSelect = require('cape-select');

var _reselect = require('reselect');

var _urlPattern = require('url-pattern');

var _urlPattern2 = _interopRequireDefault(_urlPattern);

var _utils = require('./utils');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var getLocInfo = exports.getLocInfo = (0, _get3.default)('locInfo');
var getRoutes = exports.getRoutes = (0, _capeSelect.select)(getLocInfo, 'route');
var addPattern = exports.addPattern = (0, _capeLodash.setField)('pattern', function (_ref) {
  var path = _ref.path,
      options = _ref.options;
  return new _urlPattern2.default(path, options);
});
var selectRoutes = exports.selectRoutes = (0, _reselect.createSelector)(getRoutes, (0, _mapValues3.default)(addPattern)); // Check path against specific route. If it's a match grab all info about the route.
// Calls the `validate` and `getParams` methods on the route if it has them.

var checkRoute = (0, _curry3.default)(function (loc, res, route) {
  (0, _set3.default)(res, 'params', route.pattern.match(loc.pathname));
  if (!res.params) return true;
  (0, _set3.default)(res, 'location', loc);
  (0, _set3.default)(res, 'route', route);
  return false;
});

function getLoc(locInfo) {
  var loc = (0, _isString3.default)(locInfo) ? {
    pathname: locInfo
  } : locInfo;

  if (!(0, _isString3.default)(loc.pathname)) {
    throw new Error('Must pass pathname property value must be a string.');
  }

  return (0, _utils.getLocationObject)(loc);
} // Use this if you have a simple path string.
// @TODO Look into caching?


function findRoute(routes, locInfo) {
  return (0, _transform3.default)(routes, checkRoute(getLoc(locInfo)), {});
} // route.pattern.match(path)
// Assume the use of redux-history-sync for location in state.


function routeInfoSelector(routes, history) {
  if (!history || !history.location) return history;
  return _extends({}, findRoute(routes, history.location), {
    // params
    history: history
  });
} // Take an object and turn it into a string.


function getHref(state, _ref2) {
  var routeId = _ref2.routeId,
      props = _objectWithoutProperties(_ref2, ['routeId']);

  var pattern = (0, _get3.default)([routeId, 'pattern'], selectRoutes(state));

  if (!pattern) {
    // Throw?
    console.error(routeId, 'route not found');
    return routeId;
  }

  return pattern.stringify(props);
}